import {
  getSortByRule,
  getSortByString,
  Heading,
  Table,
} from '@nbirl/nbi-common-ui-libs';
import { orderBy as _orderBy } from 'lodash';

import { useQueryParams } from '../../../../../shared/hooks';
import { TableQueryState } from '../../../../../shared/models';
import { useFolderTree } from '../../context';
import { columns } from './main-folders.contant';

export const MainFolders = () => {
  const { data } = useFolderTree();
  const folderTree = data ?? [];

  const [query, setQuery] = useQueryParams<TableQueryState>({
    pageSize: 50,
    pageIndex: 0,
    sortBy: getSortByString({ id: 'name', desc: false }),
  });
  const { ...tableState } = query;

  const sortByRule = tableState.sortBy
    ? getSortByRule(tableState.sortBy)
    : null;

  const sortedFolders =
    (sortByRule &&
      _orderBy(
        folderTree,
        sortByRule.id === 'addedBy' ? 'creator.name' : sortByRule.id,
        sortByRule.desc ? 'desc' : 'asc'
      )) ||
    folderTree;

  return (
    <>
      <Heading className="py-6 mb-1">Main folders</Heading>

      <Table
        columns={columns}
        data={sortedFolders}
        hasRowDividers
        {...tableState}
        totalCount={sortedFolders.length}
        showPagination={false}
        getRowProps={() => ({
          style: { height: '56px' },
        })}
        onStateChange={(state) =>
          setQuery({
            ...query,
            ...state,
          })
        }
      />
    </>
  );
};
